import { defineComponent } from 'vue'

// Shared client-side template-compile helper: turns a template-string (the
// same field-descriptor-driven markup website templates use) into a live Vue
// component, the same technique SitePreviewView.vue/BuilderView.vue already
// use for the website builder's live preview. Reused by the admin print
// template editor and the print material editor so both get an instant,
// no-network-round-trip preview as fields change.
export function cloneContent(value) {
  return JSON.parse(JSON.stringify(value || {}))
}

function baseData(content) {
  return {
    content: cloneContent(content || {}),
    scrolled: false,
    menuOpen: false,
  }
}

export function compilePreviewComponent(templateString) {
  if (!templateString) return null

  return defineComponent({
    template: templateString,
    props: {
      previewContent: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return baseData(this.previewContent)
    },
    watch: {
      previewContent: {
        deep: true,
        handler(next) {
          this.content = cloneContent(next || {})
        },
      },
    },
  })
}
